import { Component } from '@angular/core';
import { breadcrumb, link, stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
@Component({
  selector: 'app-addnewdashboard',
  templateUrl: './addnewdashboard.component.html',
  styleUrls: ['./addnewdashboard.component.scss']
})
export class AddnewdashboardComponent {


  translator:TranslatorPipe = new TranslatorPipe()
  header = 'Dashboards';
  links: link[] = [
    {
      name: this.translate('Go Back'),
      icon: 'pi pi-back',
      link: '/admin/dashboards',
      visible: true,
    },
  ];
  breadcrumbs: breadcrumb[] = [{ name: this.translate('data'), link: '/admin/data' }];
  stats: stat[] = [
    { name: this.translate('active'), number: 84, icon: 'pi pi-check-circle' },
    { name: this.translate('Inactive'), number: 2, icon: 'pi pi-times-circle' },
  ];

  skelition: boolean = true;
  dashboards_names: any = ["1", "2"];

  data: any[] = [];
  filteredData: any[] = [];
  searchText: string = '';

  selectedItem: any = {};
  displayDialog: boolean = false;


  constructor( public permissionService: PermissionHandlerService, private dataService: DataService, ) {}
  
  async ngOnInit() {
    this.data = await this.getDashboards()
    this.filteredData = this.data;
  }
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  private async getDashboards(): Promise<any> {
    let res = await this.dataService.getData('dashboards');
    if (res.error) {
      return;
    }
    console.log("this is the reply", res)
    this.skelition = false;
    return res.data
  }
  
  filterData() {
    if (!this.searchText) {
      // If the search text is empty, display all data
      this.filteredData = this.data;
    } else {
      // Convert search text to lowercase for a case-insensitive search
      const searchTextLower = this.searchText.toLowerCase();
      this.filteredData = this.data.filter(item =>
        item.name.toLowerCase().includes(searchTextLower) ||
        item.table.toLowerCase().includes(searchTextLower) ||
        item.graphname.toLowerCase().includes(searchTextLower) ||
        item.graphtype.toLowerCase().includes(searchTextLower)
      );
    }
  }

  editItem(item: any, rowIndex: number) {
    // Set the selectedItem to the item being edited
    this.selectedItem = { ...item, index: rowIndex };

    this.selectedItem.aggregation = JSON.stringify(this.selectedItem.aggregation)

    console.log("this is being edited", this.selectedItem)

    // Open the edit dialog
    this.displayDialog = true;
  }

  hideEditDialog() {
    this.displayDialog = false
  }
  saveEditedItem() {
    this.displayDialog = false
    console.log(this.selectedItem);
    this.data[this.selectedItem.index] = this.selectedItem
  }

}